'use client';

import { PrimeReactProvider } from 'primereact/api';
import { TranslationProvider } from '@/components/context/TranslationContext';

export default function ClientRootLayout({ children }) {
  const user = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : null;
  const isDark = user?.darkMode ?? false;

  return (
    <PrimeReactProvider value={{ cssTransition: false, ripple: true, theme: isDark ? 'dark' : 'light' }}>
      <TranslationProvider>
        {children}
      </TranslationProvider>
    </PrimeReactProvider>
  );
}